/**
 * @generated SignedSource<<272e5d11d954cfec9af0f3993f24440d>>
 * @relayHash 8aa3291c493a7381a50e9e9489461ec5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b1756a39f5fcdd48e1b306f4bbb2be0fde8cb3cabec94fdc86026fcc34c1bff6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type generalSettingsPageQuery$variables = {
  boardId: string;
};
export type generalSettingsPageQuery$data = {
  readonly boardScope: {
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
  } | null | undefined;
};
export type generalSettingsPageQuery = {
  response: generalSettingsPageQuery$data;
  variables: generalSettingsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Literal",
    "name": "isCMP",
    "value": true
  }
],
v2 = {
  "concreteType": "CurrentUser",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "permissions"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "generalSettingsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generalSettingsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b1756a39f5fcdd48e1b306f4bbb2be0fde8cb3cabec94fdc86026fcc34c1bff6",
    "metadata": {},
    "name": "generalSettingsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2a4297de8b4049e8c8f8d43032a2b73a";

export default node;
